import { AdaptiveImageCard } from '../../generic/AdaptiveImageCard';
import { ResponsivePicture } from '../../generic/ResponsivePicture';
import { BuyNowButton } from '../../generic/landing/BuyNowButton';
import { SectionTitle } from '../../generic/landing/SectionTitle';

interface IImages {
  mobile: {
    src: string;
    width: number;
  };
  tablet: {
    src: string;
    width: number;
  };
  pc: {
    src: string;
    width: number;
  };
}

interface IFeature {
  icon: string;
  text: string;
}

interface IDiscoveryProp {
  images: IImages;
  imageUrl: string;
  reversed: boolean;
  title: string;
  features: IFeature[];
}

export const DiscoveryCard = ({
  imageUrl,
  images,
  reversed,
  title,
  features,
}: IDiscoveryProp) => {
  return (
    <div className="relative">
      <div
        className={`pt-6 pb-6 lg:p-0 lg:${
          reversed ? 'mr-0' : 'mr-[-2rem]'
        } xl:mr-0`}
      >
        <AdaptiveImageCard
          reversed={reversed}
          secondChildren={
            <ResponsivePicture
              imageUrl={imageUrl}
              images={images}
              className={`relative flex items-center 
                after:content-[' '] after:h-[358px] after:w-[358px]
                after:-z-10 after:absolute after:bg-no-repeat after:right-0
                after:bg-[url('/src/assets/BackgroundRight.svg')]
                sm:after:h-[588px] sm:after:w-[588px]
                lg:after:${reversed ? 'left-0' : 'right-0 mr-0'}
                lg:after:bg-[url("${reversed ? '/src/assets/BackgroundLeft.svg' : '/src/assets/BackgroundRight.svg'}")]
                xl:after:${reversed ? 'ml-[-8rem]' : 'mr-[-8rem]'}
                after:bg-left`}
            />
          }
        >
          <div>
            <SectionTitle title={title} />
            <ul className="flex flex-col gap-6 my-8 ">
              {features.map(({ icon, text }) => (
                <li
                  key={text}
                  className="flex gap-4 flex-col items-center lg:gap-6 lg:flex-row"
                >
                  <img src={icon} alt="icon" width={48} height={48} />
                  <p className="text-center leading-[1.5] tracking-[-0.01rem] opacity-60 lg:text-left">
                    {text}
                  </p>
                </li>
              ))}
            </ul>
            <div className="flex justify-center lg:block">
              <BuyNowButton />
            </div>
          </div>
        </AdaptiveImageCard>
      </div>
    </div>
  );
};
